export default function sortArrayByObjectProperty(entries = [], property) {
	return [...entries].sort((entry1, entry2) => {
		if (entry1[property] > entry2[property]) return 1
		if (entry1[property] < entry2[property]) return -1
		return 0
	})
}
